<script setup>
import { onBeforeMount, onMounted, ref } from 'vue'
import axios                             from "axios";
import Analytics                         from "src/composables/Analytics";

const { get_cid } = Analytics();

const version_modal_title_text = ref("Update Available")
const version_modal_message_text = ref("We've made some improvements to the site. Reload the page to get the latest features.")

const show_modal = ref(false)
const checkAppVersion = async () => {
  try {
    const response = await fetch('/version.json', { cache: 'no-store' });
    const { version: latestVersion, title, message } = await response.json();

    version_modal_title_text.value = title || version_modal_title_text.value
    version_modal_message_text.value = message || version_modal_message_text.value

    if (latestVersion !== window.APP_VERSION) {
      show_modal.value = true
    }
  }
  catch (err) {
    console.error('Error checking app version:', err);
  }
}
const reload = () => {
  window.location.reload(true);
}

window.addEventListener('focus', (event) => {
  checkAppVersion()
})
setInterval(checkAppVersion, 60 * 1000); // Check every 60 seconds

onBeforeMount(() => {
  const cookies = document.cookie.split(/\s*;\s*/).map(cookie => cookie.split('='))
  const accessTokenCookie = cookies.find(x => x[0] === 'my-access-token')

  if (!accessTokenCookie) {
    localStorage.removeItem('sb-login-auth-token')
  }
})

onMounted(() => {
  setTimeout(() => {
    const tag_manager_not_defined = window.google_tag_manager === undefined;
    const datalayer_not_defined = window.dataLayer === undefined;
    if (tag_manager_not_defined || datalayer_not_defined) {
      axios.post(`https://us-central1-cp-services-304516.cloudfunctions.net/CP_Webhooks`,
          {
            event_data: {
              visitor: {
                cid: get_cid()
              },
              datalayer_not_defined,
              tag_manager_not_defined
            }
          },
          {
            headers: {
              cp_source: 'cp2'
            }
          })
    }
  }, 5000)
})
</script>

<template>
  <router-view/>
  <q-dialog v-model="show_modal" persistent>
    <q-card class="q-pa-lg more-rounded-borders" style="width: 400px">
      <q-card-section class="text-center">
        <q-avatar color="primary" text-color="white" icon="autorenew" size="50px" font-size="30px"></q-avatar>
        <div class="text-bold text-h5 q-mt-md q-mb-sm">
          {{ version_modal_title_text }}
        </div>
        <div>
          {{ version_modal_message_text }}
        </div>
      </q-card-section>
      <q-card-section class="text-center">
        <q-btn @click="reload" color="primary">Reload Now</q-btn>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

